import React, { useEffect, useState } from 'react';
import './ViolationWarning.css';

export default function ViolationWarning({ violation, count, limit = 10, onClose }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setIsVisible(true);
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        if (onClose) onClose();
      }, 300); // Wait for fade out animation
    }, 4000); // Show for 4 seconds

    return () => clearTimeout(timer);
  }, [violation, onClose]);

  const getViolationMessage = (type) => {
    const messages = {
      'voice-detected': 'Voice detected! Please remain silent during the exam.',
      'no-face': 'Face not detected. Please position yourself in front of the camera.',
      'multiple-faces': 'Multiple faces detected. Only one person should be visible.',
      'looking-away': 'Looking away detected. Please keep your focus on the screen.',
      'tab-switch': 'Tab switch detected. Please stay on the exam page.',
      'devtools-open': 'Developer tools detected. Please close them.',
      'copy': 'Copy action blocked. Copying is not allowed during the exam.',
      'blocked-shortcut': 'Shortcut blocked. Please do not use keyboard shortcuts.',
      'exit-fullscreen': 'Fullscreen exited. Please remain in fullscreen mode.',
      'fullscreen-request-failed': 'Failed to enter fullscreen. Please enable fullscreen manually.',
      'fullscreen-not-entered': 'Fullscreen mode not detected. Please enable fullscreen to continue.',
      'multiple-screens': 'Multiple monitors detected. Please disconnect additional displays and use only one monitor.',
      'camera-access-denied': 'Camera access denied. Please allow camera access.',
      'microphone-access-denied': 'Microphone access denied. Please allow microphone access.',
      'microphone-muted': 'Microphone is muted. Please unmute your microphone to continue the exam.'
    };
    return messages[type] || `Violation: ${type}`;
  };

  const getViolationIcon = (type) => {
    if (type === 'voice-detected') return '🔊';
    if (type === 'no-face' || type === 'multiple-faces' || type === 'looking-away') return '📷';
    if (type === 'tab-switch' || type === 'devtools-open' || type === 'exit-fullscreen' || type === 'fullscreen-request-failed' || type === 'fullscreen-not-entered' || type === 'multiple-screens') return '⚠️';
    return '🚫';
  };

  if (!isVisible) return null;

  // Skip camera/mic warnings if proctoring is bypassed
  const isBypassed = localStorage.getItem('proctoringBypassed') === 'true';
  const isCameraMicViolation = ['no-face', 'multiple-faces', 'camera-access-denied', 'microphone-access-denied', 'microphone-muted'].includes(violation);
  if (isBypassed && isCameraMicViolation) return null;

  const isCritical = count >= (limit - 2);

  return (
    <div className={`violation-warning ${isVisible ? 'show' : 'hide'} ${isCritical ? 'critical' : ''}`}>
      <div className="violation-content">
        <div className="violation-icon">
          {getViolationIcon(violation)}
        </div>
        <div className="violation-text">
          <div className="violation-title">Warning!</div>
          <div className="violation-message">{getViolationMessage(violation)}</div>
          <div className="violation-count">Violations: {Math.min(count, limit)} / {limit}</div>
        </div>
        <button className="violation-close" onClick={() => {
          setIsVisible(false);
          if (onClose) setTimeout(() => onClose(), 300);
        }}>
          ×
        </button>
      </div>
    </div>
  );
}

